angular.module('logbook')
  .config(['$provide', function($provide) {
    $provide.decorator('$exceptionHandler', ['$delegate', '$injector', function($delegate, $injector) {
      return function errorHandler(exception, cause) {
        
          // Dismiss standard unhandled rejection issues without a cause provided.
          if (typeof exception === 'string' && exception.includes('Possibly unhandled rejection') && cause === undefined)
            return;
          
		const errorService = $injector.get('errorService');
        errorService.handleError(exception);
		  
        $delegate(exception, cause);
      }
    }])
  }]);
